import { CommonModule } from '@angular/common';
import { Component, OnInit, OnDestroy, inject, Input, Output, EventEmitter } from '@angular/core';
import { ControlContainer, FormGroupDirective, ReactiveFormsModule } from '@angular/forms';
import { BookingFormStepEnum } from '@app/shared/models/booking-form-step.enum';
import { BookingStepsFormType } from '@app/shared/models/booking-steps-form-type.model';
import { IEmployee } from '@app/shared/models/employee.model';
import { TreatmentAssingmentArray } from '@app/shared/models/treatment-assingment-array.model';
import { ISeoTagType } from '@app/shared/services/seo/seo-tag-type.enum';
import { SEOService } from '@app/shared/services/seo/seo.service';
import { TranslateModule } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-choose-specialist',
  templateUrl: './choose-specialist.dumb.component.html',
  styleUrls: ['./choose-specialist.dumb.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    ReactiveFormsModule
  ],
  viewProviders: [{
    provide: ControlContainer,
    useExisting: FormGroupDirective
  }]
})
export class BookingPartChooseSpecialistDumbComponent implements OnInit, OnDestroy {

  @Input() assingmentId: string;
  @Input() assignmentsArray: TreatmentAssingmentArray[];
  @Output() triggerAccordionCollapse = new EventEmitter<string>();
  public parentForm: BookingStepsFormType | null;
  public allAvailableTreatmentAssingments: TreatmentAssingmentArray;
  public readonly parentFormDirective = inject(FormGroupDirective);
  private masterSubscription = new Subscription();
  private readonly seoService = inject(SEOService);

  constructor() {
    this.seoService.setSEO([
      {
        tagType: ISeoTagType.Title,
        i18nKey: 'BOOKING-PART.STEPS.CHOOSE-SPECIALIST.META-TITLE'
      },
      {
        tagType: ISeoTagType.Description,
        i18nKey: 'BOOKING-PART.STEPS.CHOOSE-SPECIALIST.META-DESCRIPTION'
      }
    ]);
  }

  ngOnInit(): void {
    this.parentForm = this.parentFormDirective.form;
    this.showAllAvailableTreatmentAssingments();
  }

  ngOnDestroy(): void {
    this.masterSubscription.unsubscribe();
  }

  public selectEmployee(employee: IEmployee | null): void {
    this.parentForm.controls.treatmentAssingments.controls[this.assingmentId].controls.employee.setValue(employee);
    this.parentForm.controls.treatmentAssingments.controls[this.assingmentId].controls.isCollapsed.setValue(true);
    this.parentForm.controls.activeStep.setValue(BookingFormStepEnum.ChooseEmployeeAndTimeSlot);
    const id = this.parentForm.controls.treatmentAssingments.controls[this.assingmentId].controls.id.value;
    this.triggerAccordionCollapse.next(id);
  }

  private showAllAvailableTreatmentAssingments(): void {
    const treatmentId = this.parentForm.controls.treatmentAssingments.value[this.assingmentId].treatment.id;
    this.allAvailableTreatmentAssingments = this.assignmentsArray.find(assingment => assingment.treatment.id === treatmentId);
  }
}
